import { render, staticRenderFns } from "./Metodos.vue?vue&type=template&id=07986048&scoped=true"
import script from "./Metodos.vue?vue&type=script&lang=js"
export * from "./Metodos.vue?vue&type=script&lang=js"
import style0 from "./Metodos.vue?vue&type=style&index=0&id=07986048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07986048",
  null
  
)

export default component.exports